import { PageTitle, PageTitleContainer } from "@/ui-components/utils/menu-items/page-title";
import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import WebhooksFetcher from "./fetcher";

const Webhooks = () => {
  const [searchParams] = useSearchParams();
  const [searchQuery] = useState(searchParams.toString() || `page=1`);
  const [reload, setReload] = useState(false);

  return (
    <div>
      <PageTitleContainer>
        <div className="flex flex-row justify-between items-center">
          <PageTitle>Webhooks</PageTitle>
        </div>
      </PageTitleContainer>
      <WebhooksFetcher searchQuery={searchQuery} setReload={setReload} reload={reload} />
    </div>
  );
};

export default Webhooks;
